import { useFilters } from "features/filters/store";
import useMapData from "../../hooks/useMapData";
import {
    Container,
    Content,
    Legend,
    MapLegendTotalValue,
    Title,
    CheckColor,
    ContentFlex,
    ContentWrapper
} from "./styles";
import { MdInfoOutline } from "react-icons/md";

export function MapInfoSemaforo() {
    const { filters: { tabBarSessaoPlanejamentoOperacional, menuName } } = useFilters();
    const { mapInfo, sidebarMenuOpen } = useMapData();
    const mapListInfo = mapInfo?.features?.filter((feature: any) => {
        return feature.properties?.planosoperacionais && feature.properties?.planosoperacionais.length > 0
    });

    const properties = mapListInfo?.map((item: any) => item.properties);
    const planos = properties?.flatMap((item: any) =>
        item.planosoperacionais.map((plano: any) => ({
            ...plano,
            tamanhoAreaHa: Number(item.tamanhoAreaHa),
        }))
    );

    const listEmDia = planos?.filter((item: any) => item.StatusSemaforo === 1);
    const listProximoVencimento = planos?.filter((item: any) => item.StatusSemaforo === 2);
    const listAtrasado = planos?.filter((item: any) => item.StatusSemaforo === 3);

    const listEmDiaSum = listEmDia.reduce((acc: any, item: any) => acc + item.tamanhoAreaHa, 0);
    const listProximoVencimentoSum = listProximoVencimento.reduce((acc: any, item: any) => acc + item.tamanhoAreaHa, 0);
    const listAtrasadoSum = listAtrasado.reduce((acc: any, item: any) => acc + item.tamanhoAreaHa, 0);

    function formatNumber(value: number | string): string {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(Number(value));
    }

    return tabBarSessaoPlanejamentoOperacional === 'execucao-operacional'
        && menuName === 'Mapa Semáforo'
        ? (
            <Container isOpenMenu={sidebarMenuOpen}>
                <Content>
                    <Legend><MdInfoOutline size={18} /> Legenda Semafórica</Legend>
                    <div>
                        <ContentFlex>
                            <CheckColor backgroundColor="#008000" />
                            <span>Em dia - Data programada &gt; 3 dias</span>
                        </ContentFlex>
                        <ContentFlex>
                            <CheckColor backgroundColor="#FFA500" />
                            <span>Próximo do vencimento - Entre hoje e 3 dias</span>
                        </ContentFlex>
                        <ContentFlex>
                            <CheckColor backgroundColor="#FF0000" />
                            <span>Atrasado - Data programada &lt; hoje</span>
                        </ContentFlex>
                    </div>
                </Content>
                <Content>
                    <Title>TOTALIZADOR DE ÁREA</Title>
                    <div>
                        <ContentWrapper>
                            <ContentFlex>
                                <CheckColor backgroundColor="#008000" />
                                <span>Em dia</span>
                            </ContentFlex>
                            <MapLegendTotalValue>{formatNumber(listEmDiaSum)} ha</MapLegendTotalValue>
                        </ContentWrapper>
                        <ContentWrapper>
                            <ContentFlex>
                                <CheckColor backgroundColor="#FFA500" />
                                <span>Próximo do vencimento</span>
                            </ContentFlex>
                            <MapLegendTotalValue>{formatNumber(listProximoVencimentoSum)} ha</MapLegendTotalValue>
                        </ContentWrapper>
                        <ContentWrapper>
                            <ContentFlex>
                                <CheckColor backgroundColor="#FF0000" />
                                <span>Atrasado</span>
                            </ContentFlex>
                            <MapLegendTotalValue>{formatNumber(listAtrasadoSum)} ha</MapLegendTotalValue>
                        </ContentWrapper>
                    </div>
                </Content>
            </Container>
        ) : null
}